import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import menGear from './men-gear.json';
import './men-gear.css';

const MenGear = () => {
	const [ searchTerm, setSearchTerm ] = useState('');

	const handleSearch = (e) => setSearchTerm(e.target.value);

	const scroll = useRef();
	const handleScrollToElement = () => {
		return scroll.current.scrollIntoView({ behavior: 'smooth' });
	};

	const handleAutoScrollToElement = () => {
		return scroll.current.scrollIntoView({ behavior: 'auto' });
	};

	return (
		<React.Fragment>
			<div ref={scroll} className="gear-container">
				<div className="gear-header-typography-container">
					<h1 className="check-our-gear-typography">Check Out Our Gear</h1>
					<h3 className="in-store-typography">In Store Only.</h3>
				</div>
			</div>
			<div className="men-products-container">
				<div className="search-section">
					<div className="search-bar-container">
						<input
							className="search-bar"
							type="text"
							placeholder="Search products..."
							onChange={handleSearch}
							value={searchTerm}
						/>
						<FaSearch className="search-icon" />
					</div>
				</div>
				<div className="category-section-container">
					<div className="category-section">
						<h1 className="men-products-typography">Men Gear</h1>
						<div className="category-breadcrumb">
							<h3>
								<Link onClick={handleAutoScrollToElement} to="all-gear">
									All
								</Link>
							</h3>
							<span>/</span>
							<h3>
								<Link onClick={handleScrollToElement} to="men-gear" className="mens-link-active">
									Men
								</Link>
							</h3>
							<span>/</span>
							<h3>
								<Link onClick={handleAutoScrollToElement} to="women-gear">
									Women
								</Link>
							</h3>
						</div>
					</div>
					<div className="product-container">
						{menGear.menGear
							.filter((item) => {
								if (!item) {
									return item;
								} else if (item.productName.toLowerCase().includes(searchTerm.toLowerCase())) {
									return item;
								}
								return null;
							})
							.map((item, id) => {
								return (
									<div
										key={id}
										style={{
											display: 'flex',
											justifyContent: 'center',
											flexDirection: 'column',
											alignItems: 'center'
										}}>
										<Link to={item.url} onClick={() => window.scrollTo(0, 0)}>
											<img src={item.img[0]} alt="clothes" />
										</Link>
										<ul>
											<li>{item.productName}</li>
											<li>Sizes | {item.sizes}</li>
											<li>${item.price}</li>
										</ul>
									</div>
								);
							})}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default MenGear;
